import React, { useEffect } from "react";
import "../Component/CardRequest.css";
import firebaseManager from "../../../../model/Firebase/FirebaseManager";
import Title from "../../../../pages/Login/Components/title/title";

const CardRequest = () => {
  const getDent = () => {
    firebaseManager.showAllDent();
  };

  useEffect(() => {
    getDent();
  }, []);

  function handleClick() {
    window.location = "/confirm";
  }

  return (
    <React.Fragment>
      <div id="noJobsAvailable" className="">
        <Title text1="No jobs availables" />
      </div>
      <div onClick={handleClick} id="datos"></div>
    </React.Fragment>
  );
};

export default CardRequest;
